const arrayToObject = (array: any, keyField: any) => array.reduce((obj: any, item: any) => {
  obj[item[keyField]] = item;
  return obj;
}, {});

export default arrayToObject;
